import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { SubscriptionInvoice, SubscriptionInvoiceCreate, SubscriptionInvoiceFilter } from '../data/subscriptionInvoice';

export function createSubscriptionInvoiceService(client: AxiosInstance) {
  return createCrudService<SubscriptionInvoice, SubscriptionInvoiceCreate, SubscriptionInvoiceFilter>(
    client,
    '/accounting/SubscriptionInvoice',
    'id',
  );
}

export type SubscriptionInvoiceService = CrudService<SubscriptionInvoice, SubscriptionInvoiceCreate, SubscriptionInvoiceFilter>;
